// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'core-js/stable';
import 'regenerator-runtime/runtime';
import Vue from 'vue'
import App from './App'
import router from './router'
import 'lib-flexible'
import {Tab, Tabs, Collapse, CollapseItem, Search, Tag, Sidebar, SidebarItem, Dialog, ImagePreview} from 'vant'
import 'vant/lib/index.css';

Vue.config.productionTip = false
Vue.use(require('vue-wechat-title'))
Vue.use(Tab)
Vue.use(Tabs)
Vue.use(Collapse)
Vue.use(CollapseItem)
Vue.use(Search);
Vue.use(Tag);
Vue.use(Sidebar);
Vue.use(SidebarItem);
Vue.use(Dialog);
Vue.use(ImagePreview);
window.Promise = Promise;
/* eslint-disable no-new */

window.app = new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js